import React from 'react';
import PropTypes from 'prop-types';
import GalleryLinks from 'images/Gallery@2x.jpg';
import ValuePropsModal from './ValuePropsModal';
import { FormattedMessage } from 'react-intl';

export default function GalleryLinksValuePropsModal({ onRequestClose }) {
  const formattedTitle = (
    <FormattedMessage
      id="ValueProps.gallerylinks.title"
      defaultMessage="Gallery Sharing"
      description="Title to name Gallery"
    />
  );

  const formattedDescription = (
    <FormattedMessage
      id="ValueProps.gallerylinks.description"
      defaultMessage="Select specific images or share every photo in a project with a single link."
      description="Description to explain what are Gallery Links"
    />
  );

  const formattedChecklistItems = [
    <FormattedMessage
      id="ValueProps.gallerylinks.valuePropA"
      defaultMessage="Choose whether or not to include details"
      description="Value prop of Gallery Links feature"
    />,
    <FormattedMessage
      id="ValueProps.gallerylinks.valuePropB"
      defaultMessage="Generate a link to send via text or email"
      description="Value prop of Gallery Links feature"
    />,
    <FormattedMessage
      id="ValueProps.gallerylinks.valuePropC"
      defaultMessage="Send to anyone, even if they don't have the app"
      description="Value prop of Gallery Links feature"
    />,
  ];

  return (
    <ValuePropsModal
      title={formattedTitle}
      description={formattedDescription}
      checklistItems={formattedChecklistItems}
      image={GalleryLinks}
      onRequestClose={onRequestClose}
    />
  );
}

GalleryLinksValuePropsModal.propTypes = {
  onRequestClose: PropTypes.func,
};
